// Nível "visualizacao": só leitura, e só nos módulos que o admin marcou.
// As permissões vêm de GET /usuarios/permissoes/me (AuthContext) e ficam em usuario.permissoes.
// O backend barra do mesmo jeito (middleware/auth.js) — isto aqui é só a parte visual.

export const MODULOS = [
  { modulo: 'dashboard', label: 'Dashboard', path: '/dashboard' },
  { modulo: 'estoque', label: 'Estoque', path: '/estoque' },
  { modulo: 'clientes', label: 'Clientes', path: '/clientes' },
  { modulo: 'vendas', label: 'Vendas', path: '/vendas' },
  { modulo: 'comissao', label: 'Comissão', path: '/comissao' },
  { modulo: 'consorcio', label: 'Consórcio', path: '/consorcios' },
  { modulo: 'crm', label: 'CRM', path: '/crm' },
  { modulo: 'financeiro', label: 'Financeiro', path: '/financeiro' },
  { modulo: 'fornecedores', label: 'Fornecedores', path: '/fornecedores' },
  { modulo: 'relatorios', label: 'Relatórios', path: '/relatorios' },
];

export const isVisualizacao = (u) => u?.nivel === 'visualizacao' || u?.role === 'visualizacao';

export const podeVerModulo = (u, modulo) => (u?.permissoes || []).includes(modulo);

// Módulo dono de um item de menu (path). null = tela que visualizacao nunca vê.
export const moduloDoPath = (path) => MODULOS.find(m => m.path === path)?.modulo || null;
